/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {Text} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {postCreateManualPayment, postResubmitPaymentImage} from '../../apis';
import {DRAWER_ROUTES} from '../../navigation/constants';
import {getSubjectNameById, px, useAsyncFn, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {LoadingButton} from '../components';
import ConfirmPurchaseModal from './ConfirmPurchaseModal';
import ImagePicker from './ImagePicker';
import ImagePickerWeb from './ImagePickerWeb';
import {PaymentErrorModal} from './PaymentErrorModal';

const Manual = ({
  navigation,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  transactionId,
  monthNumber,
  isRenew,
  handleClosePaymentModal,
}) => {
  var isPaymentError = false;
  const isLandscape = useIsLandscape();
  const [imageData, setImageData] = useState(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const subjects = useSelector((state) => state.general.subjects);
  const [isWeb] = useState(Platform.OS === 'web');

  useEffect(() => {
    return () => {
      setImageData(null);
    };
  }, []);

  if (!isRenew) {
    if (
      selectedTimeTable &&
      selectedTimeTable.length > 0 &&
      selectedTimeTable[0].scheduleId
    ) {
      console.log('Proceess to payment');
    } else {
      isPaymentError = true;
    }
  }

  const [
    {loading: createLoading},
    handleCreatePurchase,
  ] = useAsyncFn(async () => {
    if (!selectedTimeTable?.[0]?.scheduleId) {
      alert('Your payment session is expired, please try again!');
      if (isLandscape) {
        handleClosePaymentModal();
      }
      navigation.navigate(DRAWER_ROUTES.home.path);
      return;
    }

    try {
      const subjectNamesData = subjectNames
        ? subjectNames.replace(/ /g, '')
        : selectedTimeTable
            ?.map(({subjectId}) =>
              getSubjectNameById({id: subjectId, subjects}),
            )
            .join(',');

      await postCreateManualPayment({
        kidId,
        packageId,
        image: imageData,
        selectedTimeTable,
        subjectNames: subjectNamesData,
        renewData,
        monthNumber,
      });
      setIsConfirmModalVisible(true);
    } catch (error) {
      alert(String(error));
    }
  }, [kidId, packageId, imageData, selectedTimeTable, subjectNames, renewData]);

  const [
    {loading: resubmitLoading},
    handleResubmitPurchase,
  ] = useAsyncFn(async () => {
    await postResubmitPaymentImage({transactionId, image: imageData});
    setIsConfirmModalVisible(true);
  }, [transactionId, imageData]);

  const handleSubmit = () => {
    if (!imageData) {
      return alert('Please upload receipt image!');
    }

    if (transactionId) {
      handleResubmitPurchase();
    } else {
      handleCreatePurchase();
    }
  };

  const getImagePicker = () => {
    if (isWeb) {
      return <ImagePickerWeb setSelectedImage={setImageData} />;
    } else {
      return <ImagePicker setImageData={setImageData} imageData={imageData} />;
    }
  };

  const onModalClose = () => {
    setIsConfirmModalVisible(false);
    if (isLandscape) {
      handleClosePaymentModal();
    }
    navigation.navigate(DRAWER_ROUTES.home.path);
  };

  return (
    <>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      {getImagePicker()}
      <View style={styles.bottomContainer}>
        <LoadingButton
          loading={createLoading || resubmitLoading}
          style={styles.marginTop}
          onPress={handleSubmit}>
          {'Submit'}
        </LoadingButton>

        <Text style={{fontSize: 16, marginTop: px(43), fontWeight: '600'}}>
          IMPORTANT:
        </Text>
        <Text style={{fontSize: 16, marginTop: 8}}>
          {
            '1) Please bank in or transfer the stated amount to the account number provided. Then, upload the official receipt’s image. '
          }
        </Text>
        <Text style={{fontSize: 16, marginTop: 8}}>
          {'2) The account will be suspended if attempted forgery.'}
        </Text>
      </View>

      <ConfirmPurchaseModal
        title={'Thank you!'}
        text={'Your payment will be verified by the admin in two working days.'}
        onClose={() => onModalClose()}
        visible={isConfirmModalVisible}
      />
    </>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    paddingHorizontal: px(15),
    paddingVertical: px(20),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  errorText: {
    fontSize: px(20),
    marginBottom: px(20),
    textAlign: 'center',
  },
  rowContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  accountWrapper: {
    paddingHorizontal: px(17),
    paddingBottom: px(30),
    paddingTop: px(10),
    marginTop: px(17),
  },
  bankAccountText: {
    marginTop: px(17),
    fontSize: px(24),
    fontWeight: 'bold',
  },
  rowInput: {
    width: '50%',
  },
  text: {
    fontSize: px(18),
    marginTop: px(10),
  },
  bottomContainer: {
    marginTop: px(10),
    paddingHorizontal: px(17),
    paddingBottom: px(30),
  },
});

export default Manual;
